
const submissionGridComponent = {
    templateUrl: '/submissionGrid.tpl.html',
    controller: 'submissionGridController',
    bindings: {
        widgetConfig: '<',
        filterType: '<',
        alwaysShowSearch: '<'
    }
};

angular.module('gw-um-submission-grid')
    .component('uiSubmissionGrid', submissionGridComponent);
